import { render, staticRenderFns } from "./vollmachtWeb.vue?vue&type=template&id=5b86db80&"
import script from "./vollmachtWeb.vue?vue&type=script&lang=js&"
export * from "./vollmachtWeb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports